import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Taxpi92Component } from './taxpi92Pkg.component';
import { Taxpi92DetailComponent } from './taxpi92-detailPkg.component';
import { MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-taxpi92-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Taxpi92Component,
    Taxpi92DetailComponent,
  ],
  templateUrl: './taxpi92BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Taxpi92BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' taxpi92'; //###
  override masterPage!: Taxpi92Component;
  override detailPage!: Taxpi92DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
